import axios from 'axios'
import {
  requestClientInterceptor,
  requestClientInterceptorWithoutLanguage,
} from './interceptors/request/client'
import { useUserStore } from '@/stores/user'
import { useUserMetricsStore } from '@/stores/userMetrics'
import { useModalsStore } from '@/stores/modals'

const isClient = typeof window !== 'undefined'

const api = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const apiV2BaseURL = import.meta.env.DEV
  ? '/subscriptions-api'
  : import.meta.env.VITE_PUBLIC_API_BASE_URL_V2

const apiV2 = axios.create({
  baseURL: apiV2BaseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const apiKeycloak = axios.create({
  baseURL: import.meta.env.VITE_KEYCLOAK_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

if (isClient) {
  const responseClientInterceptor = (error) => {
    if (
      error?.response?.status === 409 &&
      error?.response?.data?.code === 'LIMIT_EXCEEDED'
    ) {
      const userStore = useUserStore()
      if (userStore.isProUser) {
        return Promise.reject(error)
      }

      const { kind } = error.response.data
      const userMetricsStore = useUserMetricsStore()
      const modalsStore = useModalsStore()
      const modalTypeByKind = {
        consultations: 'consultations',
        recording: 'recordingTime',
        customPrompt: 'customPrompts',
        tabs: 'maxTabsLimit',
      }

      const mappedModalType = modalTypeByKind[kind]
      if (mappedModalType) {
        userMetricsStore.resourceLimitModalType = mappedModalType
        modalsStore.showResourceUseLimitModal = true
      }
    }
    return Promise.reject(error)
  }

  api.interceptors.request.use(requestClientInterceptor)
  api.interceptors.response.use(null, responseClientInterceptor)
  // subscriptions API não usa x-daai-language; enviar o header quebra o preflight CORS
  apiV2.interceptors.request.use(requestClientInterceptorWithoutLanguage)
  apiV2.interceptors.response.use(null, responseClientInterceptor)
  apiKeycloak.interceptors.request.use(requestClientInterceptorWithoutLanguage)
}

export { api, apiV2, apiKeycloak }
